import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.landing.gradientFrom},
    ${({ theme }) => theme.landing.gradientVia},
    ${({ theme }) => theme.landing.gradientTo}
  );
`;

export const LoginCard = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid rgba(203, 196, 210, 0.3);
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.xl};
  box-shadow: 0px 20px 40px -10px ${({ theme }) => theme.colors.shadow};
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 440px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.lg};
  }
`;

export const BrandAnchor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Heading = styled.h1`
  font-weight: 600;
  font-size: 1.875rem;
  line-height: 1.2;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.landing.text};
  margin: 0;
  padding-top: 12px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.5rem;
  }
`;

export const FormSection = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  padding-bottom: ${({ theme }) => theme.spacing.md};
`;

export const PasswordHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const PasswordLabel = styled.label`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const ForgotPasswordLink = styled.a`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const PasswordInputWrapper = styled.div`
  width: 100%;
  margin-top: 4px;
  position: relative;
`;

export const SignInButton = styled.button`
  width: 100%;
  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.spacing.md};

  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const SignUpText = styled.p`
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};
  margin: 0;
  padding-top: ${({ theme }) => theme.spacing.xl};
  text-align: center;

  span {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.landing.text};
  opacity: 0.6;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.landing.buttonBg};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
